import React from 'react';
import { useSelector } from 'react-redux';
import PortfolioRow from './portfolioRow/index';

const PortfolioList = () => {
    const portfolioList = useSelector(state => state.portfolios.portfolioList);
    return (
        <div className="app-main-content">
            {portfolioList.map((entry, index) => <PortfolioRow key={index} portfolio={entry} /> )}
        </div>
    );
};

export default PortfolioList;


// WEBPACK FOOTER //
// ./components/Agile/portfolio/portfolioList/index.js